'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLoaderSpinner = require('react-loader-spinner');

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('../../../sass/components/spinner.scss');

var Spinner = function (_Component) {
    _inherits(Spinner, _Component);

    function Spinner(props) {
        _classCallCheck(this, Spinner);

        return _possibleConstructorReturn(this, (Spinner.__proto__ || Object.getPrototypeOf(Spinner)).call(this, props));
    }

    _createClass(Spinner, [{
        key: 'render',
        value: function render() {

            var spinnerClass = "spinner-container";
            var spinnerParentClass = this.props.classNames;

            if (spinnerParentClass) {
                spinnerClass = "spinner-container spinner-box";
            }

            var SpinnerComponent = _react2.default.createElement(
                'div',
                { id: "spinner-container-box", className: spinnerClass, style: { display: this.props.disply ? this.props.disply : "none" } },
                _react2.default.createElement(_reactLoaderSpinner.ThreeCircles, {
                    height: '60',
                    width: '60',
                    color: '#808080',
                    wrapperStyle: {},
                    wrapperClass: 'loader',
                    visible: true,
                    ariaLabel: 'three-circles-rotating'
                })
            );

            return SpinnerComponent;
        }
    }]);

    return Spinner;
}(_react.Component);

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Spinner.js
// module id = 354
// module chunks = 0